import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMessage, sendMessage } from 'src/store/modules/chat/actions';
import { mountMessage } from 'src/store/modules/chat/functions';

export function useMountSendMessage() {
  const dispatch = useDispatch();
  const user_id = useSelector((state: any) => state.chat?.config?.user?.id);
  const handleMountSendMessage = useCallback(
    (text: string, chat: any) => {
      const messageToStore = mountMessage(chat, text, 'suggestion');
      const messageToSend = {
        chat_id: chat?.id,
        channel_id: chat?.view.selectedChannel.id,
        user_id,
        contact_id: chat?.contact?.id,
        external_id: chat?.contact?.externals.find(
          (external: any) => external.selected === true
        )?.id,
        message_body: text,
        cuid: messageToStore.cuid,
        type: messageToStore.type,
      };
      dispatch(addMessage(messageToStore));
      dispatch(sendMessage(messageToSend));
    },
    [dispatch, user_id]
  );

  return { handleMountSendMessage };
}
